export const FUEL_STATIONS_COMMAND_NODE = "get_fuel_stations"
export const FUEL_STATIONS_NS = "urn:slickshift:fuel-stations:0"

export type FuelStation = {
  lat: number
  lon: number
  color: string
  icon?: string
  category?: string
  name: string
  address: string
}

// Unique category names (Google My Maps layer names) in order of first
// appearance. Empty for accounts whose stations carry no categories.
export const fuelStationCategories = (stations: FuelStation[]): string[] => {
  const categories: string[] = []
  stations.forEach((station) => {
    if (station.category && !categories.includes(station.category)) {
      categories.push(station.category)
    }
  })
  return categories
}

const FUEL_STATION_COLORS: Record<string, string> = {
  green: "#14ae5c",
  blue: "#2563eb",
  yellow: "#eab308",
  red: "#dc2626",
}

export const normalizeFuelStationColor = (color: string): string => {
  return FUEL_STATION_COLORS[color.toLowerCase()] ?? color
}

// Brand icons matching the ones used on the account's own fuel stations map
// (e.g. Google My Maps for sobanscy.eu). Keys arrive in the `icon` attribute
// of the fuel stations ad-hoc command response.
export const FUEL_STATION_ICONS: Record<string, string> = {
  shell: "/fuel-icons/shell.png",
  ids: "/fuel-icons/ids.png",
  sobanscy_energy: "/fuel-icons/sobanscy-energy.png",
  barmalgas: "/fuel-icons/barmalgas.png",
  alternoil: "/fuel-icons/alternoil.png",
  vulcangas: "/fuel-icons/vulcangas.png",
  closed: "/fuel-icons/closed.png",
}

export const fuelStationIconImageId = (icon: string) => `fuel-station-${icon}`
